import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { downloadString } from 'utils'

import csvJson from './export.json'
import moment from 'moment'

const useExport = ({equipments}) => {
  const { t } = useTranslation()
  const { hardwareType } = useParams()

  const create = async () => {
    const type = hardwareType || 'blends'
    if (!csvJson['expand'][type]) {
      return null
    }

    let csvContent = 'data:text/csv;charset=utf-8,'

    const headerKeys = csvJson['expand'][type].header
    const translatedHeaders = headerKeys.map(head => t(`supervision.tables.${head}`).toUpperCase())
    const header = translatedHeaders.join(',').concat('\r\n')

    const content = equipments[type]
      .filter(({ site }) => Boolean(site))
      .map((equipment) => {
        return [
          equipment.label || '-',
          equipment.available_level === 'up' ? 'Ok' : 'Down',
          `${equipment.site?.name || '-'} / ${equipment.building_name || '-'}`,
          equipment.floor_name || '-',
          equipment.room || '-',
          equipment.model || '-',
          equipment.manufacturer || '-'
        ].join(',').concat('\r\n')
      })
      .join('')

    const dataString = csvContent.concat(header, content)
    await downloadString({ dataString, fileName: `equipments_${moment().format('YYYY/MM/DD HH:mm')}.csv` })
  }

  return create
}

export default useExport